import React, { useContext } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { UPDATE_RESULT_HAND_MUTATION } from 'api/queries'
import { StateContext, DispatchContext } from 'store/contexts'
import {
  UPDATE_RESULT_HAND,
  GO_TO_DIGEST_SCREEN,
  ADD_UI_STATE,
} from 'store/actions'
import {
  getPercentValueOfRange,
  getPercentage,
  FILIGREE_ROTATE_ANIM_BASE_DEGREES,
} from 'global'
import { IHand } from 'models'
import { Flex, HandBuilder } from 'components'
import { useScreenTrack, trackButtonInteraction } from 'api/tracking'

interface UpdateResultHand {
  resultId: string
  hand: Omit<IHand, 'cards'>
}

interface UpdateHandReturnValue {
  updateResultHand: IHand
}

const HandScreen = () => {
  const state = useContext(StateContext)
  const dispatch = useContext(DispatchContext)
  const [updateResultHand] = useMutation<
    UpdateHandReturnValue,
    { params: UpdateResultHand }
  >(UPDATE_RESULT_HAND_MUTATION)
  const hand = state.result.hand

  const handleCompleteHandBuilder = (
    handOpts: Pick<IHand, 'color' | 'animal'>
  ) => {
    const params = { resultId: state.result.id, hand: handOpts }
    updateResultHand({ variables: { params } }).then((res) => {
      if (res.data) {
        dispatch({
          type: UPDATE_RESULT_HAND,
          payload: { hand: res.data.updateResultHand },
        })
      }
      dispatch({ type: GO_TO_DIGEST_SCREEN })
    })
  }

  const handleCardRotate = (rotation: number) => {
    const digestBgOpac = getPercentValueOfRange(
      getPercentage(Math.abs(rotation), 180, true),
      1.0
    )
    const filigreeOpac = getPercentValueOfRange(
      getPercentage(Math.abs(rotation), 180, false),
      1.0,
      0.3
    )

    dispatch({
      type: ADD_UI_STATE,
      payload: {
        filigree: {
          transform: `rotate(${
            FILIGREE_ROTATE_ANIM_BASE_DEGREES - rotation
          }deg)`,
          opacity: filigreeOpac,
        },
        digestBg: { opacity: digestBgOpac },
      },
    })

    trackButtonInteraction('Flip Card', 'Rotate')
  }

  useScreenTrack('hand')

  return (
    <Flex
      height='100%'
      width={1}
      flexDirection='column'
      padding={[3, '16px 10%', '16px 15%']}
      justifyContent={['space-between', 'center']}
    >
      <Flex
        height='100%'
        className='handbuilder-container'
        alignItems={['unset', 'unset', 'unset', 'center']}
      >
        <HandBuilder
          selectedColor={hand.color}
          selectedAnimal={hand.animal}
          onComplete={handleCompleteHandBuilder}
          onCardRotate={handleCardRotate}
        />
      </Flex>
    </Flex>
  )
}

export default HandScreen
